import { connect } from 'react-redux'
import EmailRequired from './email-required'
import { getCurrentState } from './redux/email-required.selectors'

const mapStateToProps = state => {
  const currentState = getCurrentState(state)
  return {
    identityConnectMessageSent: currentState.identityConnectMessageSent
  }
}

export default connect(
  mapStateToProps,
  null
)(EmailRequired)
